module.exports = __webpack_public_path__ + "img/email-third.bb51ef2b.svg";